/**
 * db-bundle-builder: multi-product pack picker (spec: specs/db-bundle-builder.md).
 *
 * Each slot resolves its selection against a slim variant JSON emitted by the snippet.
 * Availability is computed BOTH directions (unlike the vendor PDP picker, which is
 * forward-only): picking a size marks colors without that size, and vice versa.
 * Unavailable values stay clickable; selecting one auto-corrects the other option to
 * the first available combination.
 *
 * Add to cart: one POST to /cart/add.js with all component variants plus hidden
 * _db_bundle / _db_bundle_key line properties, requesting the cart-drawer and
 * cart-bubble sections in the same call (Cart Ajax API `sections`). On success the
 * fresh sections are swapped in exactly like the vendor renderContents pattern and
 * the native cart drawer opens (ADR-0006). If the drawer is unavailable, fall back
 * to /cart.
 */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function parseVariants(slot) {
    var json = slot.querySelector('[data-db-slot-variants]');
    if (!json) {
      return null;
    }
    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
  }

  function Slot(el) {
    this.el = el;
    this.variants = parseVariants(el) || [];
    this.single = el.querySelector('[data-db-single-variant]');
    this.options = Array.prototype.slice.call(el.querySelectorAll('.db-bundle-option'));
    this.priceEl = el.querySelector('[data-db-slot-price]');
    this.imageEl = el.querySelector('[data-db-slot-image]');
  }

  Slot.prototype.currentOptions = function () {
    var values = [];
    this.options.forEach(function (opt) {
      var checked = opt.querySelector('input[type="radio"]:checked');
      values[parseInt(opt.dataset.dbOptionIndex, 10)] = checked ? checked.value : null;
    });
    return values;
  };

  Slot.prototype.selectedVariant = function () {
    if (this.single) {
      var id = parseInt(this.single.value, 10);
      return this.variants.find(function (v) { return v.id === id; }) || (this.variants[0] || null);
    }
    var current = this.currentOptions();
    return this.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return current[i] === null || current[i] === undefined || current[i] === opt;
      });
    }) || null;
  };

  // If the current combination has no available variant, move the OTHER options to the
  // first available variant that keeps the just-changed value.
  Slot.prototype.autoCorrect = function (changedIndex) {
    var current = this.currentOptions();
    var match = this.selectedVariant();
    if (match && match.available) {
      return;
    }
    var keep = current[changedIndex];
    var target = this.variants.find(function (v) {
      return v.options[changedIndex] === keep && v.available;
    });
    if (!target) {
      return; // whole value is sold out; leave selection, button-side guard reports it
    }
    this.options.forEach(function (opt) {
      var i = parseInt(opt.dataset.dbOptionIndex, 10);
      var input = Array.prototype.find.call(
        opt.querySelectorAll('input[type="radio"]'),
        function (r) { return r.value === target.options[i]; }
      );
      if (input && !input.checked) {
        input.checked = true;
      }
    });
  };

  // Mark values with no available variant given the OTHER currently-selected options.
  // Uses the theme's own is-disabled input class (product.css .variations scope) so the
  // diagonal-strike treatment matches the regular PDP picker exactly. Inputs stay
  // clickable; selecting one auto-corrects the other option.
  Slot.prototype.refreshAvailability = function () {
    var self = this;
    var current = this.currentOptions();
    this.options.forEach(function (opt) {
      var i = parseInt(opt.dataset.dbOptionIndex, 10);
      opt.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var candidate = current.slice();
        candidate[i] = input.value;
        var ok = self.variants.some(function (v) {
          return v.available && v.options.every(function (o, j) {
            return candidate[j] === null || candidate[j] === undefined || candidate[j] === o;
          });
        });
        input.classList.toggle('is-disabled', !ok);
      });
    });
  };

  Slot.prototype.render = function () {
    var variant = this.selectedVariant();
    this.options.forEach(function (opt) {
      var checked = opt.querySelector('input[type="radio"]:checked');
      var valueEl = opt.querySelector('.form__label__value');
      if (checked && valueEl) {
        valueEl.textContent = checked.value;
      }
    });
    if (this.priceEl) {
      if (variant) {
        var html = money(variant.price);
        if (variant.compare_at_price > variant.price) {
          html = '<s>' + money(variant.compare_at_price) + '</s> ' + html;
        }
        this.priceEl.innerHTML = html;
      } else {
        this.priceEl.textContent = '';
      }
    }
    if (this.imageEl && variant && variant.image) {
      this.imageEl.src = variant.image;
    }
    this.refreshAvailability();
  };

  function initBuilder(root) {
    var slots = Array.prototype.map.call(root.querySelectorAll('.db-bundle-slot'), function (el) {
      return new Slot(el);
    });
    var totalEl = root.querySelector('[data-db-total]');
    var errorEl = root.querySelector('[data-db-error]');
    var addBtn = root.querySelector('[data-db-add]');

    function renderTotal() {
      var total = 0;
      var compare = 0;
      var complete = true;
      slots.forEach(function (slot) {
        var v = slot.selectedVariant();
        if (v) {
          total += v.price;
          compare += Math.max(v.compare_at_price, v.price);
        } else {
          complete = false;
        }
      });
      if (totalEl) {
        if (complete) {
          var html = money(total);
          if (compare > total) {
            html = '<s>' + money(compare) + '</s> ' + html;
          }
          totalEl.innerHTML = html;
        } else {
          totalEl.textContent = '';
        }
      }
      return complete;
    }

    function renderAll() {
      slots.forEach(function (slot) { slot.render(); });
      renderTotal();
    }

    function showError(message) {
      if (!errorEl) {
        return;
      }
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (errorEl) {
        errorEl.hidden = true;
      }
    }

    slots.forEach(function (slot) {
      slot.el.addEventListener('change', function (e) {
        var opt = e.target.closest('.db-bundle-option');
        if (!opt) {
          return;
        }
        clearError();
        slot.autoCorrect(parseInt(opt.dataset.dbOptionIndex, 10));
        renderAll();
      });
    });

    // Swap in the fresh section HTML returned by the add call using the vendor
    // CartDrawer element's OWN render table and parser (#Cart-Drawer IS the
    // <cart-drawer> custom element; getSectionsToRender/getSectionInnerHTML are its
    // public methods), so there is no shadow copy of the vendor id/selector table to
    // drift on Reformation upgrades. The drawer opens ONLY after every section
    // swaps cleanly: the pack is already in the cart by this point, and a drawer
    // showing pre-add contents invites double-adds, so ANY render failure
    // (missing/null sections, vendor selector change, drawer or app.js globals
    // unavailable) falls back to the always-correct /cart page instead.
    function openCartOrRedirect(data) {
      var cartDrawer = document.getElementById('Cart-Drawer');
      function redirect() {
        window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
      }
      // Vendor add paths dispatch cart:item-added after a successful add; app.js
      // maps it to the CartLinesUpdateEvent standard event (web pixels). The add
      // has succeeded whichever way we surface it, so dispatch before branching.
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart:item-added', { product: data && data.items ? data.items[0] : data });
      }
      if (!cartDrawer || typeof OverlayManager === 'undefined' || !OverlayManager.open || typeof cartDrawer.getSectionsToRender !== 'function') {
        redirect();
        return;
      }
      try {
        cartDrawer.getSectionsToRender().forEach(function (entry) {
          var target = document.getElementById(entry.id);
          if (!target) {
            return; // vendor parity: absent render targets are skipped
          }
          if (!data || !data.sections || !data.sections[entry.section]) {
            throw new Error('missing section ' + entry.section);
          }
          (target.querySelector(entry.selector) || target).innerHTML =
            cartDrawer.getSectionInnerHTML(data.sections[entry.section], entry.selector);
        });
      } catch (err) {
        redirect();
        return;
      }
      OverlayManager.open(cartDrawer);
      dispatchCustomEvent('cart-drawer:open');
      addBtn.classList.remove('loading');
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.classList.contains('loading')) {
          return;
        }
        clearError();
        var items = [];
        var soldOut = false;
        var key = 'dbb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
        slots.forEach(function (slot) {
          var v = slot.selectedVariant();
          if (!v || !v.available) {
            soldOut = true;
            return;
          }
          items.push({
            id: v.id,
            quantity: 1,
            properties: { _db_bundle: root.dataset.dbBundle, _db_bundle_key: key }
          });
        });
        if (soldOut || items.length !== slots.length) {
          showError('One of your picks is sold out. Choose another color or size for it.');
          return;
        }
        addBtn.classList.add('loading');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: 'cart-drawer,cart-bubble',
            sections_url: window.location.pathname
          })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || data.message || 'Could not add the pack to your cart.');
            });
          }
          return res.json();
        }).then(function (data) {
          openCartOrRedirect(data || {});
        }).catch(function (err) {
          addBtn.classList.remove('loading');
          showError(err.message || 'Could not add the pack to your cart. Please try again.');
        });
      });
    }

    renderAll();
  }

  function init() {
    document.querySelectorAll('.db-bundle-builder').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
